import React from "react";
import { ROUTE_PAGE } from "config/RoutePage";
import { Route, Redirect } from "react-router-dom";
import { AuthManager } from "service/AuthManager";
export default function PrivateRoute({ component: Component, ...rest }: any) {
  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route
      {...rest}
      render={(props) =>
        //isLogin() ? <Component {...props} /> : <Redirect to="/signin" />
        AuthManager.isLogin() ? (
          <Component {...props} />
        ) : (
          <Redirect to={ROUTE_PAGE.AUTH.LOGIN} />
        )
      }
    />
  );
}
